import Request from '../util/request'
import {ajax} from "../util/ajaxUtil";

const path = "/eip-mapp-oa-server"

export function getListPage(data) {//分页获取放行条数据
    return Request({
      url: path + '/oa_seal_form/page',
      method: 'post',
      data: data
    })
}

export function getCurrentTaskCount(params) {//获取商务支持部服务申请当前任务数
    let data;
    ajax({
        url: path + '/fl_marketing_center/getCurrentTaskCount',
        method: 'post',
        contentType: 'application/json;charset=utf-8',
        data: params,
        success: function (res) {
            if (res.success) {
                data = res.data;
            }
        },
        async: false
    })
    return data;
}


